import { useState } from 'react';
import kit from './kit.module.css';
import styles from './TopicBoundariesDemo.module.css';

interface Prompt {
  label: string;
  response: string;
  action: string;
}

const PROMPTS: Prompt[] = [
  {
    label: 'Write me a cover letter',
    response:
      "Cover letters aren't something I'm set up for just yet, but they're on our roadmap. For now, I can help you create a strong CV that makes your cover letter easier to write. Want to start with that?",
    action: 'Create CV instead',
  },
  {
    label: 'Help me prepare for my interview',
    response:
      "Interview prep is a bit outside my lane - I focus on getting you to the interview stage with a great CV. For interview coaching, a service like Interview Prep might help. Ready to work on your CV?",
    action: 'Work on CV',
  },
  {
    label: 'What jobs should I apply for?',
    response:
      "Job matching isn't something I do, but once you have a strong CV we can tailor it to specific roles you're interested in. Do you have a role or sector in mind?",
    action: 'Tailor CV to a role',
  },
];

export function TopicBoundariesDemo() {
  const [active, setActive] = useState<Prompt | null>(null);

  return (
    <div className={kit.root}>
      <div className={kit.row}>
        <span className={kit.agentIcon} aria-hidden="true">✦</span>
        <span className={styles.agentName}>CV Assistant</span>
        <span className={`${kit.chip} ${styles.scope}`}>Scope: CVs</span>
      </div>

      <div className={styles.thread} aria-live="polite">
        {!active && <p className={kit.feedback}>Pick an off-topic request below to see how the agent responds.</p>}
        {active && (
          <>
            <div className={kit.bubbleUser}>{active.label}</div>
            <div className={kit.bubbleAgent}>
              <p className={styles.text}>{active.response}</p>
              <button className={`${kit.btn} ${kit.btnPrimary}`} onClick={() => setActive(null)}>
                {active.action}
              </button>
            </div>
          </>
        )}
      </div>

      <div className={styles.input} aria-hidden="true">Ask the assistant...</div>

      <div className={kit.stack}>
        <span className={kit.label}>Try asking</span>
        <div className={kit.row}>
          {PROMPTS.map((p) => (
            <button
              key={p.label}
              className={`${kit.chip} ${styles.preset} ${active === p ? styles.presetActive : ''}`}
              onClick={() => setActive(p)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
